import request from './request'

/**
 * 获取 文件异步导出表列表
 * @param page
 * @param limit
 */

export const getPageList = (pageInfo) => {
    const params = {
        page: pageInfo.page,
        limit: pageInfo.limit,
        url: pageInfo.url,
        type: pageInfo.type,
        result: pageInfo.result
    }
    return request({
        url: 'admin/file/adm/fileExportAsync/getListPage',
        params,
        method: 'get'
    })
}

export const getMyDownloadPage = (pageInfo) => {
    const params = {
        page: pageInfo.page,
        limit: pageInfo.limit,
        url: pageInfo.url,
        type: pageInfo.type,
        result: pageInfo.result
    }
    return request({
        url: 'admin/file/adm/fileExportAsync/getMyDownloadPage',
        params,
        method: 'get'
    })
}

/**
 * 添加接口
 *  id  ID
 *  userId  员工id
 *  fileId  文件id
 *  fileName  文件名称
 *  bussinessCode  业务编码
 *  requestUrl  请求url
 *  requestType  状态：0get、1post
 *  params  参数
 *  status  状态：0已发起、1处理中、2已完成
 *  downloadUrl  下载链接
 *  insertBy  创建者：如果为系统初始数据填0
 *  insertDate  创建时间
 *  lastUpdateBy  更新者：最后更新者，如果为系统初始数据填0
 *  lastUpdateDate  更新时间
 *  version  版本号
 *  delFlag  删除标记：逻辑删除标记（1：显示；2：删除）
 * */
export const addFileExportAsync = (fileExportAsync
) => {
    const data = {
        userId: fileExportAsync.userId,
        fileId: fileExportAsync.fileId,
        fileName: fileExportAsync.fileName,
        bussinessCode: fileExportAsync.bussinessCode,
        requestUrl: fileExportAsync.requestUrl,
        requestType: fileExportAsync.requestType,
        params: fileExportAsync.params,
        status: fileExportAsync.status,
        downloadUrl: fileExportAsync.downloadUrl,
        version: fileExportAsync.version,
    }
    return request({
        url: 'admin/file/adm/fileExportAsync/addFileExportAsync',
        data,
        method: 'post'
    })
}

/**
 * 更新接口
 * * id  ID
 * * userId  员工id
 * * fileId  文件id
 * * fileName  文件名称
 * * bussinessCode  业务编码
 * * requestUrl  请求url
 * * requestType  状态：0get、1post
 * * params  参数
 * * status  状态：0已发起、1处理中、2已完成
 * * downloadUrl  下载链接
 * * insertBy  创建者：如果为系统初始数据填0
 * * insertDate  创建时间
 * * lastUpdateBy  更新者：最后更新者，如果为系统初始数据填0
 * * lastUpdateDate  更新时间
 * * version  版本号
 * * delFlag  删除标记：逻辑删除标记（1：显示；2：删除）
 * *
 */
export const updateFileExportAsync = (fileExportAsync
) => {
    const data = {
        id: fileExportAsync.id,
        userId: fileExportAsync.userId,
        fileId: fileExportAsync.fileId,
        fileName: fileExportAsync.fileName,
        bussinessCode: fileExportAsync.bussinessCode,
        requestUrl: fileExportAsync.requestUrl,
        requestType: fileExportAsync.requestType,
        params: fileExportAsync.params,
        status: fileExportAsync.status,
        downloadUrl: fileExportAsync.downloadUrl,
        version: fileExportAsync.version,
    }
    return request({
        url: 'admin/file/adm/fileExportAsync/updateFileExportAsync',
        data,
        method: 'post'
    })
}

/**
 * 删除
 * @param id
 */
export const removeFileExportAsync = (id) => {
    const data = {
        id: id
    }
    return request({
        url: 'admin/file/adm/fileExportAsync/delFileExportAsync',
        data,
        method: 'post'
    })
}
